import moment from 'moment-timezone';
import React from 'react';
import { useFormikContext } from 'formik';

import { formTypes } from '../../../store/catalogs/forms';
import Calendar from '../../inputs/Calendar/Calendar';
import NumberInput from '../../inputs/NumberInput/NumberInput';
import Select from '../../inputs/Selects/Select/Select';
import Switch from '../../inputs/Switch/Switch';
import TextInput from '../../inputs/TextInput/TextInput';
import TextArea from '../TextArea/TextArea';
import Phone from '../../inputs/Phone/Phone';
import Radios from '../../inputs/Radios/Radios/Radios';
import Checkboxes from '../../inputs/Checkboxes/Checkboxes/Checkboxes';
import Identification from '../../inputs/Identification/Identification';

import classes from './FormGrid.module.scss';
import Password from '../../inputs/Password/Password';

const FormGrid = ({ className, subtitle, fields, onChange, Render, description, isCustomErrorCheck = false, isSubtitle = false }) => {
  const { values, errors, touched, setFieldTouched } = useFormikContext();
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  const onBlur = (key, value) => {
    if (isCustomErrorCheck) setFieldTouched(key, value);
  };

  return (
    <>
      <div className={`${classes.title} ${isSubtitle && (subtitle || description) ? classes.margin : ''}`}>
        {subtitle && <span className={`${!isSubtitle ? classes.subtitle : ''} semibold-18`}>{subtitle}</span>}
        {description && <span className='medium-14'>{description}</span>}
      </div>
      <div className={containerClasses.join(' ')}>
        {fields
          .filter(item => (item.show ? item.show(values) : true))
          .map(
            ({
              key,
              type = 'input',
              label,
              placeholder,
              popover,
              options,
              validate,
              keyIndicative,
              cols,
              disabled,
              disabledType,
              keyType,
              textHelper,
              optionsType,
              topPosition = 'top-right'
            }) => {
              const value = key.split('.').reduce((prev, key) => prev[key], values);
              let field = <div></div>;
              if (!!key && !!label) {
                field = (
                  <TextInput
                    disabled={disabled}
                    placeholder={placeholder ? placeholder : label}
                    id={key}
                    name={key}
                    onBlur={() => onBlur(key, true)}
                    validated={!!!errors[key] && !!touched[key] && !!validate}
                    error={!!errors[key] && !!touched[key]}
                    type='text'
                    onChange={value => onChange(key, value)}
                    value={value}
                  />
                );
              }

              if (type === formTypes.select || type === formTypes.selectCreate || type === formTypes.selectComplete) {
                field = (
                  <Select
                    disabled={disabled}
                    options={options}
                    placeholder='Selecciona'
                    error={!!errors[key] && !!touched[key]}
                    typeSelect={type}
                    name={key}
                    value={value}
                    onChange={
                      //(newValue)=> typesSelect[type] ? typesSelect[type](key,newValue) :
                      type === formTypes.select ? newValue => onChange(key, newValue.value) : newValue => onChange(key, newValue)
                    }
                  />
                );
              } else if (type === formTypes.switch) {
                field = <Switch checked={value} onChange={value => onChange(key, value)} />;
              } else if (type === formTypes.password) {
                field = (
                  <Password
                    disabled={disabled}
                    placeholder={placeholder ? placeholder : label}
                    id={key}
                    name={key}
                    onBlur={() => onBlur(key, true)}
                    //validated={!!!errors[key] && !!touched[key] && !!validate}
                    error={!!errors[key] && !!touched[key]}
                    onChange={value => onChange(key, value)}
                    value={value}
                  />
                );
              } else if (type === formTypes.number || type === formTypes.percent || type === formTypes.money) {
                field = (
                  <NumberInput
                    name={key}
                    placeholder={placeholder ? placeholder : label}
                    disabled={disabled}
                    error={!!errors[key] && !!touched[key]}
                    validated={!!!errors[key] && !!touched[key] && !!validate}
                    prefix={type === formTypes.money ? '$' : type === formTypes.percent ? '%' : ''}
                    onBlur={() => onBlur(key, true)}
                    onChange={numberData => {
                      onChange(key, numberData);
                    }}
                    value={value}
                    thousandSeparator={type === formTypes.money}
                    typeOfNumber={[formTypes.money, formTypes.percent].includes(type) ? "float" : "integer"}
                  />
                );
              } else if (type === formTypes.date) {
                field = (
                  <Calendar
                    disabled={disabled}
                    format='dd/MM/yyyy'
                    //left={true}
                    value={moment(value)}
                    onChange={date => {
                      if (date) {
                        // Usar componentes locales de la fecha para evitar problemas de timezone
                        const d = new Date(date);
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        onChange(key, `${year}-${month}-${day}`);
                      }
                    }}
                    minDate={options?.min ? moment(options.min).startOf('day').toDate() : undefined}
                    maxDate={options?.max ? moment(options.max).endOf('day').toDate() : undefined}
                    name={key}
                  />
                );
              } else if (type === formTypes.textArea) {
                field = <TextArea value={value} onChange={value => onChange(key, value)} />;
              } else if (type === formTypes.phone) {
                const currentKeysIndicative = keyIndicative.split('.');
                const valueIndicative =
                  currentKeysIndicative.length === 1
                    ? values[keyIndicative]
                    : values[currentKeysIndicative[0]][currentKeysIndicative[1]][currentKeysIndicative[2]];
                field = (
                  <Phone
                    name={key}
                    key={key}
                    errorIndicative={!!errors[keyIndicative] && !!touched[keyIndicative]}
                    keyIndicative={keyIndicative}
                    keyNumber={key}
                    onBlur={() => onBlur(key, true)}
                    valueIndicative={valueIndicative}
                    onChangeIndicative={newValue => onChange(keyIndicative, newValue.value)}
                    onChange={newValue => onChange(key, newValue)}
                    validate={!!!errors[key] && !!touched[key] && !!validate}
                    error={!!errors[key] && !!touched[key]}
                    value={value}
                  />
                );
              } else if (type === formTypes.radio) {
                field = <Radios className='input-radios' options={options} value={value} onChange={value => onChange(key, value)} />;
              } else if (type === formTypes.checkbox) {
                field = (
                  <Checkboxes
                    onChangeKeys={value => onChange(key, value)}
                    options={options}
                    validated={!!!errors[key] && !!touched[key] && !!validate}
                    error={!!errors[key] && !!touched[key]}
                  />
                );
              } else if (type === formTypes.identification) {
                const currentKeysType = keyType.split('.');
                const keyAux = key;
                const valueType =
                  currentKeysType.length === 1 ? values[keyType] : values[currentKeysType[0]][currentKeysType[1]][currentKeysType[2]];
                field = (
                  <Identification
                    optionsType={optionsType}
                    disabledType={disabledType}
                    disabled={disabled}
                    name={keyAux}
                    key={keyAux}
                    keyType={keyType}
                    onBlur={() => onBlur(keyAux, true)}
                    errorIndicative={!!errors[keyType] && !!touched[keyType]}
                    valueType={valueType}
                    onChange={newValue => onChange(keyAux, newValue)}
                    onChangeKey={newValue => onChange(keyType, newValue.value)}
                    validate={(!!!errors[keyAux] || !!!errors[keyType]) && !!touched[keyAux] && !!validate}
                    error={(!!errors[keyAux] || !!errors[keyType]) && !!touched[keyAux]}
                    value={value}
                    topPosition={topPosition}
                  />
                );
                if (!!errors[keyType]) {
                  key = keyType;
                } else if (!!errors[keyAux]) {
                  key = keyAux;
                }
              }

              const renderClasses = [];
              if (cols === 2) {
                renderClasses.push(classes['span-2-cols']);
              }
              return (
                <Render className={renderClasses.join(' ')} key={key} name={key} label={label} popover={popover}>
                  {field}
                  {textHelper && !((!!errors[key] || !!errors[keyType]) && !!touched[key]) && (
                    <span className={`${classes.helper} medium-12`}>{textHelper}</span>
                  )}
                </Render>
              );
            }
          )}
      </div>
    </>
  );
};

export default FormGrid;
